module.exports = __webpack_public_path__ + "static/media/ddaf6b25.jpg";